import React, {useState, useEffect}  from "react";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import { addDays, format, getWeek, endOfWeek, isWithinInterval } from "date-fns";
import { 
  Body1Stronger,
  Subtitle2Stronger,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
  mergeClasses,
  Table, 
  TableHeader, 
  TableHeaderCell, 
  TableBody, 
  TableRow, 
  TableCell,
  } from "@fluentui/react-components";
import WeekRow from "./WeekRow";
import EntryCellEditor from "./EntryCellEditor";
import EntryCell from "./EntryCell";
import DayCombined from "./DayCombined";
import Totals from "./Totals";
import Leave from "./Leave"
import TooltipWatcherWidget from "../../components/TooltipWatcherWidget";
import {formatDisplayDate} from '../../services/TimeFunctions';
import PrevButton from "./PrevButton"
import HolidayRow from "./HolidayRow"

export default function WeekView(props) {
  const [dayCombinedOpen, setdayCombinedOpen]= useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dayCombinedEntries, setDayCombinedEntries] = useState(null);

  const [entryDialogOpen, setEntryDialogOpen]= useState(false);
  const [entryData, setEntryData] = useState({});
  const [entryDay, setEntryDay] = useState({});
  const{currentWeekStart, isDesktop, useStyles, dateToggle }= useGlobalStatus();
  const classes = useStyles();
  const [suggestedStartDict, setSuggestedStartDict] = useState({});

  const handleEntryCellAction= (data, day)=>{
    setEntryData(data);
    setEntryDay(day);
    setEntryDialogOpen(true);
  }

  const handleUpdateWeekView=(data,day) => {
    props.handleEntryCellAction(data,day);
  }

  const handleDialogClose=()=>{
    setEntryDialogOpen(false);
    setdayCombinedOpen(false);
  };

  const handleSetDayCombinedEntries = (date) => {
    const entries = []
    props.timesheetData.forEach(client => {
        client.projects.forEach(project => {
            project.budgets.forEach(budget => {
                budget.timecodes.forEach(timecode => {
                    timecode.entryDays.forEach(day => {
                        if (day.date.getTime() === date.getTime() && day.status !== "empty") {
                          day.entries.forEach(entry => {
                            entries.push([entry, project, timecode]);
                          });
                        }
                    });
                });
            });
        });
    });
    entries.sort((a, b) => a[0].start.localeCompare(b[0].start));
    setDayCombinedEntries(entries);
  }

  useEffect(() => {

    const TOTAL_HOURS = 8;

    //Convert stringin the 02:32 string format to a decimal with hours.minutes

    const toDecimalHours = (timeStr) => {
      if(timeStr == null) return
      //split at the semicolon and convert each to a number
        const [hrs, mins] = timeStr.split(":").map(Number);
        // divide by 60 to make sur
        return hrs + (mins / 60);
    };

    //Convert decimal in theo the 02:32 string format
    const toHourString = (timeNumber) => { 
      const displayHours = Math.floor(timeNumber);
      const displayMinutes = Math.round((timeNumber - displayHours) * 60);
      //Make sure to pad a 0 so it maintains the 02:02 rather than 2:2
      return `${String(displayHours).padStart(2, '0')}:${String(displayMinutes).padStart(2, '0')}`;
    }

    // Fill it with null values initally
    const suggestedStartDictTemp = {}
    for(var i=0; i<7; i++){
      suggestedStartDictTemp[format(addDays(currentWeekStart,i),'dd/MM/yyyy')] = { start: null, end: null, totalTime: 0 };
    }


    props.timesheetData.forEach(client => {
        client.projects.forEach(project => {
            project.budgets.forEach(budget => {
                budget.timecodes.forEach(timecode => {

                    timecode.entryDays.forEach(day => {
                        if (day.status !== "empty") {
                          day.entries.forEach(entry => {
                            
                            const dateKey = format(day.date, 'dd/MM/yyyy');
                      
                            // Convert to decimal for calculations
                            const entryStart = toDecimalHours(entry.start);
                            const entryEnd = toDecimalHours(entry.end);

                            let current = suggestedStartDictTemp[dateKey];
                            
                            // Adding this as I noticed errors that the total time is null when cycling weeks quickly
                            if (!current) {
                              current = suggestedStartDictTemp[dateKey] = {
                                start: null,
                                end: null,
                                totalTime: 0
                              };
                            }

                            // Keep track of the currently worktime by the hours in the entry
                            current.totalTime += (entryEnd - entryStart);

                            //Make sure that if its null, set the values to the current entry values
                            if (current.start === null) {
                              current.start = entry.start;
                              current.end = entry.end;
                            } else {
                              if (entryStart < toDecimalHours(current.start)) current.start = entry.start;
                              if (entryEnd > toDecimalHours(current.end)) current.end = entry.end;
                            }
                          });
                        }
                    });
                });
            });
        });
    });

  for (let i = 0; i < 7; i++) {
    const dateKey = format(addDays(currentWeekStart, i), 'dd/MM/yyyy');
    const current = suggestedStartDictTemp[dateKey];

    // If its null default to a standard 9 to 5
    if(current.start == null){
      current.start = "09:00";
      current.end = "17:00"
      continue;
    }

    // let startTime = toDecimalHours(current.start)
    let endTime = toDecimalHours(current.end)
    
    // Calculate the remaining time based on the set total 
    // Round so that it wont be 8 picosections remaining due to floating points
    const remainingTime = Math.round(TOTAL_HOURS - current.totalTime)
    
   current.start = current.end;
   //  They've worked all or more than the expected hoursm set the end value to be an extra hour
    if (remainingTime <= 0) {
      current.end = toHourString(endTime + 1)
    }
    else{
      // Set the end value to be the full time after the remaining
      current.end = toHourString(endTime + remainingTime)
    }

    // If that end hour goes past 24/midnight set it to 23:59  no matter what.
    if(toDecimalHours(current.end) >= 24){
      suggestedStartDictTemp[dateKey].end = "23:59"
    }
  }

    setSuggestedStartDict(suggestedStartDictTemp);
  }, [props.timesheetData]);
  

  const dates=[];
  const weekDays=["Mon","Tues","Wed","Thur","Fri","Sat","Sun"]
  for(var i=0; i<7; i++){
    var day = addDays(currentWeekStart,i);
    dates.push([format(day,'do, LLL'), weekDays[i], day]);
  }
  
  const calculateTotal = (data, day) => {
        var exclude;
        if(day==null) exclude = new Date(1900,1,1);
        else exclude = day.date;

        var total = 0;
        
        var validDays = data.entryDays.filter(q=> q.status!=='empty' && q.status!=='error' && q.date!== exclude && 
            isWithinInterval(q.date, {start: currentWeekStart, end: addDays(endOfWeek(currentWeekStart),1)}));
        total = (validDays.reduce( function(total, item){                
                return total + (
                    item.entries.reduce(function(dayTotal, entry){
                        return dayTotal + entry.totalMinutes;
                    },0));
            }, 
        0));     
        return (formatDisplayDate(total, dateToggle));
    }
  return (
    <>
      {isDesktop? (
        <>
        <Table 
        style={{ 
            width: '100%', 
            tableLayout: 'fixed', // Forces headers to align perfectly with body columns
            borderCollapse: 'collapse', 
            backgroundColor: 'transparent',
            border: 'none' ,
            boxShadow: '0 -5px 5px -5px rgba(0,0,0,0.2)',
          }}
        className="week-view-table">
          <TableHeader>

          <TableRow>
            <TableHeaderCell style={{ backgroundColor: 'transparent', border: 'none'}} colSpan={2}></TableHeaderCell >
            {dates.map((instance, index) => (
              
                <TableHeaderCell style={{ backgroundColor: 'transparent', border: 'none', cursor:"default"}} className="week-view-table-days"  key={index}>
                    <PrevButton 
                    timesheetData={props.timesheetData} 
                    prevWeekTimesheetData={props.prevWeekTimesheetData}
                    style={{fontSize:12}}
                    setTimesheetData={props.setTimesheetData} 
                    selectedDay={instance[2]}
                    changeAmount="day"
                    btnMessage="Day"
                    ></PrevButton>      
                </TableHeaderCell>
  
              ))}
                <TableHeaderCell style={{ backgroundColor: 'transparent', border: 'none', cursor:"default"}} className="week-view-table-days">
                    <PrevButton 
                    timesheetData={props.timesheetData} 
                    prevWeekTimesheetData={props.prevWeekTimesheetData}
                    style={{fontSize:12}}
                    setTimesheetData={props.setTimesheetData} 
                    btnMessage="week" 
                    selectedDay={dates[0][0]}
                    changeAmount="week"></PrevButton>
                </TableHeaderCell>
          </TableRow>

          <TableRow style={{    zIndex: 10,boxShadow: "0 -4px 12px -4px rgba(0, 0, 0, 0.06)"}}>
            <TableHeaderCell style={{width: '200px', fontWeight: "bold"}}>Project</TableHeaderCell>
            <TableHeaderCell style={{fontWeight: "bold" }}>Timecode</TableHeaderCell>
            {dates.map((instance, index) => (
            (instance[1] === "Thur") ? 
            <TableHeaderCell className="week-view-table-days" onClick={()=> {setSelectedDate(instance[2]); handleSetDayCombinedEntries(instance[2]); setdayCombinedOpen(true);}}  key={index}>
              <TooltipWatcherWidget text="Click to see all entries for a day, providing a unified location to view, edit and delete entries" direction="below-end">
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: "center", textAlign: "center", width: '100%', padding: '0.25rem'}} >
                  <div style={{fontWeight: "bold"}}>{instance[1]}</div>
                  <div>{instance[0]}</div>
                </div>
                </TooltipWatcherWidget>
            </TableHeaderCell>
            :
            <TableHeaderCell className="week-view-table-days" onClick={()=> {setSelectedDate(instance[2]); handleSetDayCombinedEntries(instance[2]); setdayCombinedOpen(true);}} key={index}>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: "center", textAlign: "center", width: '100%', padding: '0.25rem'}} >
                  <div style={{fontWeight: "bold"}}>{instance[1]}</div>
                  <div>{instance[0]}</div>
                </div>
            </TableHeaderCell>
          ))}
          <TableHeaderCell>
          <TooltipWatcherWidget text="Total hours for the week for each timecode or leave" direction="above-end">
              <Body1Stronger style={{display: 'flex', justifyContent: "center", width: '100%'}}>Total</Body1Stronger>
            </TooltipWatcherWidget>
          </TableHeaderCell>
        </TableRow>
        </TableHeader>
        <TableBody>


        {
        props.timesheetData.map((client) => (
          <React.Fragment key={`c${client.clientId}`}>
            {client.projects.map((project) => {
              const timecodeRows = [];

              project.budgets.forEach((budget) => {
                budget.timecodes.forEach((timecode) => {
                  timecodeRows.push({ timecode, budget });
                });
              });

              if (timecodeRows.length === 0) return null;

              return timecodeRows.map(({ timecode, budget }, index) => (
                <TableRow key={`c${client.clientId}-p${project.projectId}-b${budget.budgetId}-t${timecode.taskId}-${index}`}>
                  {/* Show project name only on the first row */}
                  {index === 0 ? (
                    <TableHeaderCell rowSpan={timecodeRows.length}>
                      <Subtitle2Stronger>{project.projectName}</Subtitle2Stronger>
                    </TableHeaderCell>
                  ) : null}

                  {/* Timecode name */}
                  <TableCell style={{backgroundColor: '#eff1f5'}}>
                    {timecode.taskName}
                  </TableCell>

                  {/* Week view cells */}
                  <WeekRow
                    data={timecode}
                    keybase={`c${client.clientId}-p${project.projectId}-b${budget.budgetId}-t${timecode.taskId}-w${getWeek(currentWeekStart)}`}
                    handleEntryCellAction={handleEntryCellAction}
                    timesheetData={props.timesheetData}
                    setTimesheetData={props.setTimesheetData} 
                  />
                </TableRow>
              ));
            })}
          </React.Fragment>
        ))}
        <Leave leaveData={props.leaveData} />
      <TableRow>
        <Totals timesheetData={props.timesheetData} leaveData={props.leaveData}/>
      </TableRow>
      <HolidayRow setCalendarData={props.setCalendarData} calendarData={props.calendarData}/>

      </TableBody>
          

      {/* Entry Cell Editor */}
      <EntryCellEditor
        timesheetData={props.timesheetData}
        dialogOpen={entryDialogOpen}
        entryData={entryData}
        entryDay={entryDay}
        setEntryDay={setEntryDay}
        handleDialogClose={handleDialogClose}
        handleUpdateWeekView={handleUpdateWeekView}
        suggestedStartDict={suggestedStartDict}
        setSuggestedStartDict={setSuggestedStartDict}
      />
      <DayCombined
        timesheetData={props.timesheetData}
        dialogOpen={dayCombinedOpen}
        date={selectedDate}
        entries={dayCombinedEntries}
        handleDialogClose={handleDialogClose}
        handleUpdateWeekView={handleUpdateWeekView}
      />
      
      </Table>
      
      </>
      ) : (
        <>



        <HolidayRow setCalendarData={props.setCalendarData} calendarData={props.calendarData}/>

        <Accordion collapsible>
            <AccordionItem value="CopyButtons">
              <AccordionHeader className={mergeClasses(classes.accordionHeader)}>Add your Previous Entries!</AccordionHeader>
              <AccordionPanel className={mergeClasses(classes.accordionPanel)}>

              
                <PrevButton 
                timesheetData={props.timesheetData} 
                prevWeekTimesheetData={props.prevWeekTimesheetData}
                style={{fontSize:12}}
                setTimesheetData={props.setTimesheetData} 
                btnMessage="Week" 
                selectedDay={dates[0][0]}
                changeAmount="week"></PrevButton>

          
             
                {dates.map((instance, index) => (
                  <PrevButton  key={index} 
                  timesheetData={props.timesheetData} 
                  prevWeekTimesheetData={props.prevWeekTimesheetData}
                  style={{fontSize:12}}
                  setTimesheetData={props.setTimesheetData} 
                  selectedDay={instance[2]}
                  changeAmount="day"
                  btnMessage="Day"
                  ></PrevButton>
              ))}
              </AccordionPanel>
            </AccordionItem>



          {props.timesheetData.map((client, clientIndex) =>
            client.projects
              .map((project, projectIndex) => (
                project.budgets
                .map((budget, budgetIndex) => (
                  budget.timecodes
                .map((timecode, timecodeIndex) => (
                  <AccordionItem  
                  key={`acc-item-${client.clientId}-${project.projectId}-${budget.budgetId}-${timecode.taskId}`}
                  value={`${clientIndex}-${projectIndex}-${budgetIndex}-${timecodeIndex}`}>
                    <AccordionHeader className={mergeClasses(classes.accordionHeader)}>{project.projectName} - {timecode.taskName} - {calculateTotal(timecode)}</AccordionHeader>
                    <AccordionPanel className={mergeClasses(classes.accordionPanel)}>
                      {timecode.entryDays.map((day) => (
                          <EntryCell 
                          key={`entry-${clientIndex}-${projectIndex}-${budgetIndex}-${timecodeIndex}-${day.date}`}
                          handleEntryCellAction={handleEntryCellAction} 
                          data={day}
                          setTimesheetData={props.setTimesheetData}
                          timecodeData={timecode}
                          //project and budget id needs to be set
                          budgetId={timecode.budgetId}
                          projectId={timecode.projectId}
                          />
                      ))}
                    </AccordionPanel>
                  </AccordionItem>
                ))
              ))    
            ))
          )}
          <Leave leaveData={props.leaveData}></Leave>
        </Accordion>
        </>
      )}
      {/* Entry Cell Editor */}
      <EntryCellEditor
        timesheetData={props.timesheetData}
        leaveData={props.leaveData}
        dialogOpen={entryDialogOpen}
        entryData={entryData}
        entryDay={entryDay}
        setEntryDay={setEntryDay}
        handleDialogClose={handleDialogClose}
        handleUpdateWeekView={handleUpdateWeekView}
        suggestedStartDict={suggestedStartDict}
        setSuggestedStartDict={setSuggestedStartDict}
      />
    </>
  );
}